export const AppRoutes = {
  homeSlash: "/",
  pharmacyAi: "/pharmacy-ai",
  cybersecurity: "/cybersecurity",
  about: "/about",
  contact: "/contact",
  news: "/news",
  newsDetail: "/news/:slug",
  privacy: "/privacy-policy",
  cookies: "cookies-settings",
};
